import React from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../components/layout/Header';
import { ContactDetail } from '../components/contacts/ContactDetail';

export function ContactDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>Ungültige Kontakt-ID</div>;
  }

  return (
    <>
      <Header title="Kontakt" subtitle="Details & Ankaufsprofile" />
      <div className="content">
        <ContactDetail id={id} />
      </div>
    </>
  );
}
